import React from 'react';
import ReactDOM from 'react-dom/client';


import App from './App';

import "./css/style.css"
import "./css/responsive.css"
import "./css/animated.css"
import "./css/fontawesome.css"
import "./css/templatemo-plot-listing.css"
import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);